import { getBasePath } from "@/services/_bit/UiService";

export default {
  methods: {
    getNormalizedRoute(page) {
      return { name: page };
    },

    checkCurrentPage(page) {
      return this.$route.name === page;
    },

    isRoutePathActive(path, parentRoute) {
      if (!parentRoute) return false;

      const normalizedPath = path.replace(/\/+$/, "") || "/";
      const normalizedParentRoute = parentRoute.replace(/\/+$/, "") || "/";

      return (
        normalizedPath === normalizedParentRoute ||
        normalizedPath.startsWith(`${normalizedParentRoute}/`)
      );
    },

    checkActivePage({ page, subItems }) {
      const parentRoute = page ? this.$router.resolve({ name: page }).href : page;
      const pageSubItems = subItems ? subItems.map((subItem) => subItem.page) : [];
      const { path: routePath, name: routeName } = this.$route;
      const path = `${getBasePath()}${routePath}`;

      return (
        this.checkCurrentPage(page) ||
        this.isRoutePathActive(path, parentRoute) ||
        pageSubItems.includes(routeName)
      );
    },

    getRoute({ page, subItems, link }) {
      const isActivePage = this.checkActivePage({ page, subItems });
      const isPresentSubItems = !!subItems?.length;

      if (link || !page) return null;

      if (!this.checkCurrentPage(page) && (!isActivePage || !isPresentSubItems)) {
        return this.getNormalizedRoute(page);
      }

      return null;
    },
  },
};
